/**
 * Notification Toast Component
 *
 * Toast emergente para mostrar notificaciones en tiempo real
 */

import React, { useEffect } from "react";
import { Snackbar, Alert, AlertTitle, Box, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useNotifications } from "../contexts/NotificationContext";

const NotificationToast = () => {
  const { toastNotification, closeToast } = useNotifications();
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    console.log("🍞 NotificationToast effect triggered:", toastNotification);
    if (toastNotification) {
      console.log("🍞 Opening toast for:", toastNotification.title);
      setOpen(true);
    }
  }, [toastNotification]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setTimeout(() => {
      closeToast();
    }, 300);
  };

  if (!toastNotification) {
    return null;
  }

  // Mapear tipo a severidad de MUI Alert
  const getSeverity = (type) => {
    const severityMap = {
      success: "success",
      info: "info",
      warning: "warning",
      error: "error"
    };
    return severityMap[type] || "info";
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ mt: 8 }} // Margen superior para evitar ocultar el AppBar
    >
      <Alert
        onClose={handleClose}
        severity={getSeverity(toastNotification.type)}
        variant="filled"
        sx={{
          width: "100%",
          maxWidth: 400,
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)"
        }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <AlertTitle sx={{ fontWeight: 700 }}>
          {toastNotification.title}
        </AlertTitle>
        <Box>{toastNotification.message}</Box>
      </Alert>
    </Snackbar>
  );
};

export default NotificationToast;
